<!-- Start Content-->
<div class="container-fluid">
  <div class="row my-1">
      <div class="col-md-12">
          <div class="userTables">

              <div class="searchForm">
                  <form>
                      <div class="row">
                          <div class="col-md-3">
                              <!-- <label>Search</label> -->
                              <input type="text" class="form-control" [(ngModel)]="search" [ngModelOptions]="{standalone: true}"
                                placeholder="search by user id">
                          </div>
                          <div class="col-md-3">
                              <button type="submit" class="btn btn-gets" (click)="getData('', search)"> <i class="mdi mdi-search-web"></i> Search</button>
                          </div>
                      </div>
                  </form>
              </div>

              <div class="row">
                  <div class="col-12">
                      <h2>Admin</h2>
                      <div class="table-responsive">
                          <table class="table mb-0 table-bordered">
                              <thead>
                                  <tr>
                                    <th>Username</th>
                                    <th>Credit Ref</th>
                                    <th>balance</th>
                                    <th>P/L</th>
                                    <th>Exposure</th>
                                    <th>Client Share</th>
                                    <th>Up-line</th>
                                    <th>status</th>
                                    <th>Bet</th>
                                    <th>Remove</th>
                                    <th>Options</th>
                                  </tr>
                              </thead>
                              <tbody *ngIf="data && data?.children?.data.length > 0">

                                <tr *ngFor="let item of data?.children?.data; trackBy:trackByIndex;">
                                  <td>
                                    <div class="btn-group">
                                      <a href="javascript:void(0)" class="btn btn-option">{{item?.role_id == 1 ? 'A' : item?.role_id == 2 ? 'S' : item?.role_id == 3 ? 'M' : 'C'}}</a>
                                      &nbsp;&nbsp;
                                    </div>
                                    <a *ngIf="item?.role_id != 4" href="javascript:void(0)"
                                      routerLink="/users/child/{{item?.id}}">{{item?.username}}
                                      ({{item?.name}})</a>
                                    <span class="color-bk" *ngIf="item?.role_id == 4">{{item?.username}}
                                      ({{item?.name}})</span>
                                  </td>
                                  <td>{{fixedPostDecimal(item?.balance, 2)}}</td>
                                  <td>{{fixedPostDecimal(item?.available_balance, 2)}}</td>
                                  <td>{{fixedPostDecimal(item?.pl, 2)}}</td>
                                  <td>
                                    <a  href="javascript:void(0)" [routerLink]="item?.role_id == 4 ? ['/expose-detail', item?.id] : ['/market-analysis',item?.id]">{{fixedPostDecimal(item?.expose, 2)}}</a>
                                  </td>
                                  <td>{{item?.partnership}}</td>
                                  <td>
                                    <a  href="javascript:void(0)" *ngIf="router.url.includes('users/child/') && item?.parent?.id != user?.id" routerLink="/users/child/{{user?.id}}/{{item?.parent?.username}}">{{item?.parent?.username}}</a>
                                    <!-- <a  href="javascript:void(0)" *ngIf="router.url.includes('blocked-child') && item?.parent?.id != user?.id" routerLink="/users/blocked-child/{{user?.id}}/{{item?.parent?.username}}">{{item?.parent?.username}}</a> -->
                                    <a  href="javascript:void(0)" *ngIf="router.url.includes('child_by_type') && item?.parent?.id != user?.id" routerLink="/users/child_by_type/{{item?.parent?.role_id}}/{{item?.parent?.username}}">{{item?.parent?.username}}</a>
                                    <span *ngIf="item?.parent?.id == user?.id || router.url.includes('blocked-child')" >{{item?.parent?.username}}</span>
                                  </td>
                                    <!-- <a  href="javascript:void(0)" (click)="getData('', item?.parent?.username, data?.user?.id)">{{item?.parent?.username}}</a></td> -->
                                  <!-- <td><a href="javascript:void(0)" routerLink="/users/child_by_type/{{item?.role_id-1}}/{{item?.parent?.username}}">{{item?.parent?.username}}</a></td> -->
                                  <td>
                                    <a href="javascript:void(0)" (click)="confirmBox('status-l', item)" *ngIf="item?.is_active == 1"
                                      class="btn-unlock"><i class="mdi mdi-lock-open" aria-hidden="true"></i></a>
                                    <a href="javascript:void(0)" (click)="confirmBox('status-ul', item)"
                                      *ngIf="item?.is_active == 0 || item?.is_active == null" class="btn-lock"><i class="mdi mdi-lock"
                                        aria-hidden="true"></i></a>
                                  </td>
                                  <td>
                                    <a href="javascript:void(0)" (click)="confirmBox('bet-l', item)" *ngIf="item?.bet_locked_by == null"
                                      class="btn-unlock"><i class="mdi mdi-lock-open" aria-hidden="true"></i></a>
                                    <a href="javascript:void(0)" (click)="confirmBox('bet-ul', item)" *ngIf="item?.bet_locked_by != null"
                                      class="btn-lock"><i class="mdi mdi-lock" aria-hidden="true"></i></a>
                                  </td>
                                  <td>
                                    <a href="javascript:void(0)" class="btn-trash" (click)="confirmBox('delete', item)"><i
                                        class="mdi mdi-trash-can" aria-hidden="true"></i></a>
                                  </td>
                                  <td>
                                                                     
                                    <div class="btn-group" dropdown>
                                      <!-- <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
                                        (click)="openModal(editModal,item?.id, 'ep',item?.username)" title="Edit Profile"><i class="mdi mdi-pencil"
                                          aria-hidden="true"></i></a> -->
                                      <a *ngIf="item?.role_id != 4" href="javascript:void(0)" id="button-autoclose1" dropdownToggle
                                        class="btn btn-l dropdown-toggle" aria-controls="button-autoclose1">
                                        <i class="mdi mdi-plus" aria-hidden="true"></i>
                                      </a>
                                      <ul id="button-autoclose1" *dropdownMenu class="dropdown-menu" role="menu"
                                        aria-labelledby="button-autoclose1">
                                        <li role="menuitem" *ngFor="let ulist of env?.userList;">
                                          <a class="dropdown-item" href="javascript:void(0)"
                                            routerLink="/user-create/{{item?.id}}/{{ulist?.id}}"
                                            *ngIf="ulist.cIds.includes(item?.role_id)">{{ulist?.name}}</a>
                                        </li>
                                      </ul>
                                      
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" (click)="openModal(depositModal,item?.id+''+item?.role_id, 'd', item?.username)" title="Chip Deposit">d</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" (click)="openModal(withdrawModal,item?.id+''+item?.role_id, 'w', item?.username)" title="Chip Withdraw">w</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" routerLink="/reports/settlement-report/{{item?.id}}" title="Settlement Report">s/r</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" routerLink="/reports/account-statement-new/{{item?.id}}" title="Account Statement">a/c</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" (click)="confirmBox('password', item)" title="Reset Password">p</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" (click)="openModal(reportsModal, item?.id, 'r', item?.username)" title="Reports">R</a>
                                      <a href="javascript:void(0)" *ngIf="!env.host.userListNewDesign" class="btn btn-option" data-toggle="tooltip" data-placement="top" (click)="openModal(settingsModal,item?.id, 's', item?.username)" title="Settings">s</a>
                                    </div>

                                    <div class="btn-group" dropdown *ngIf="env.host.userListNewDesign">
                                      <a class="dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg fill="#000000" width="800px" height="800px" viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M26,16a8,8,0,1,1,8-8A8,8,0,0,1,26,16ZM26,4a4,4,0,1,0,4,4A4,4,0,0,0,26,4Z"/><path d="M26,34a8,8,0,1,1,8-8A8,8,0,0,1,26,34Zm0-12a4,4,0,1,0,4,4A4,4,0,0,0,26,22Z"/><path d="M26,52a8,8,0,1,1,8-8A8,8,0,0,1,26,52Zm0-12a4,4,0,1,0,4,4A4,4,0,0,0,26,40Z"/></svg>
                                      </a>
                                      <div class="dropdown-menu" aria-bs-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="openModal(depositModal,item?.id+''+item?.role_id, 'd', item?.username)">deposit</a>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="openModal(withdrawModal,item?.id+''+item?.role_id, 'w', item?.username)">withdrawal</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/settlement-report/{{item?.id}}">Settlement Report</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/account-statement-new/{{item?.id}}">Account Statement</a>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="confirmBox('password', item)">Reset Password</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/chip-statement/{{item?.id}}">Chip Statement</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/chip-summary/{{item?.id}}">Balance Summary</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/profit-loss/{{item?.id}}">Profit Loss</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/sport-report/{{item?.id}}">Sports Profit Loss</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/bet-history/{{item?.id}}">Bets History</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/pending-bet-history/{{item?.id}}">Pending Bets</a>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="openModal(editModal,item?.id, 'ep',updateProfileName)">Edit Profile</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/user-setting/{{item?.id}}">Settings</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/casino-setting/{{item?.id}}">Casino Settings</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/icasino-setting/{{item?.id}}">iCasino Settings</a>
                                        <a class="dropdown-item" href="javascript:void(0)" routerLink="/sport-setting/{{item?.id}}">Sport Settings</a>

                                      </div>
                                    </div>
                                    
                                  </td>
                                </tr>

                              </tbody>

                              <tbody *ngIf="data && data?.children?.data?.length == 0">
                                <tr>
                                  <td colspan="10" class="noData"> {{env.noDataMsg}}</td>
                                </tr>
                              </tbody>

                              <tbody *ngIf="!data">
                                <tr>
                                  <td colspan="10">
                                    <app-loader class="no-overlay"></app-loader>
                                  </td>
                                </tr>
                              </tbody>
                          </table>

                          <!-- pagination -->
                          <app-pagination [data]="data?.children" (changePage)="getData($event)"></app-pagination>
                          <!-- pagination -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


    <!-- Edit modal -->

    <ng-template #editModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Edit to {{updateProfileName}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-update-profile [updateProfileId]="updateProfileId" (closeModal)="closeModal($event)">
        </app-update-profile>
      </div>
    </ng-template>

    <!-- deposit modal -->
    <ng-template #depositModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Deposit to {{updateProfileName}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-deposit [uId]="updateProfileId" (closeModal)="closeModal($event)"></app-deposit>
      </div>
    </ng-template>
    <!-- deposit modal -->

    <!-- withdraw modal -->
    <ng-template #withdrawModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Withdraw from {{updateProfileName}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-withdraw [uId]="updateProfileId" (closeModal)="closeModal($event)"></app-withdraw>
      </div>
    </ng-template>
    <!-- withdraw modal -->

    <!-- Reports modal -->
    <ng-template #reportsModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Reports of {{updateProfileName}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="btn-group" dropdown>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/reports/chip-statement/{{updateProfileId}}" title="Chip Statement">c/s</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/reports/chip-summary/{{updateProfileId}}" title="Balance Summary">b/s</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/reports/profit-loss/{{updateProfileId}}" title="Profit Loss">p/l</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/reports/sport-report/{{updateProfileId}}" title="Sports Profit Loss">s/pl</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/bet-history/{{updateProfileId}}" title="Bets History">bh</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/pending-bet-history/{{updateProfileId}}" title="Pending Bets">pb</a>

        </div>
      </div>
    </ng-template>
    <!-- Reports modal -->

    <!-- Reports modal -->
    <ng-template #settingsModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Settings of {{updateProfileName}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="btn-group" dropdown>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
          (click)="modalRef?.hide()" (click)="openModal(editModal,updateProfileId, 'ep',updateProfileName)" title="Edit Profile"><i class="mdi mdi-pencil"
              aria-hidden="true"></i></a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/user-setting/{{updateProfileId}}" title="Settings">s</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/casino-setting/{{updateProfileId}}" title="Casino Settings">cs</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/icasino-setting/{{updateProfileId}}" title="iCasino Settings">ics</a>
          <a href="javascript:void(0)" class="btn btn-option" data-toggle="tooltip" data-placement="top"
            (click)="modalRef?.hide()" routerLink="/sport-setting/{{updateProfileId}}" title="Sport Settings">ss</a>
        </div>
      </div>
    </ng-template>
    <!-- Reports modal -->
